import { useState } from "react";
import { newsList, hotRank } from "@/mocks/home";

export default function FreshSection() {
  const tabs = ["全部", "剧集", "综艺", "音乐", "偶像", "动漫", "时尚"];
  const [active, setActive] = useState("全部");
  const [liveTip, setLiveTip] = useState(false);

  const shown = active === "全部" ? newsList : newsList.filter((n) => n.cat === active);

  return (
    <section id="fresh" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-time-line"></i>今日更新持续刷新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              今日新鲜瓜料
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              实时更新滚动播报，点开卡片查看实时动态与最新进展。
            </p>
          </div>
          <button
            type="button"
            onClick={() => setLiveTip(true)}
            onBlur={() => setTimeout(() => setLiveTip(false), 200)}
            className="relative whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-accent-600"
          >
            <i className="ri-refresh-line mr-1.5"></i>刷新动态
            {liveTip && (
              <span className="absolute right-0 top-full z-20 mt-2 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-xs text-background-100 shadow-sm">
                已是最新，约每 5 分钟更新一次
              </span>
            )}
          </button>
        </div>

        {/* 分类 Tab 切换 */}
        <div
          className="mt-6 inline-flex flex-wrap items-center gap-1 rounded-full bg-secondary-100 p-1"
          role="tablist"
          aria-label="资讯分类筛选"
        >
          {tabs.map((t) => (
            <button
              key={t}
              type="button"
              role="tab"
              aria-selected={active === t}
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition ${
                active === t
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-secondary-200"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {shown.length === 0 ? (
          <div className="mt-8 rounded-xl border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">「{active}」暂无内容，换个分类看看吧</p>
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {shown.map((n, i) => (
              <article
                key={n.id}
                className="fade-up group overflow-hidden rounded-xl border border-background-200 bg-background-100 transition hover:border-primary-200"
                style={{ animationDelay: `${i * 0.05}s` }}
              >
                <div className="relative block h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={n.img}
                    alt={n.title}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-foreground-950/80 px-2 py-1 text-xs font-semibold text-background-50 backdrop-blur-sm">
                    <i className="ri-time-line"></i>{n.time}
                  </span>
                  <span
                    className={`absolute right-3 top-3 rounded-md px-2 py-1 text-xs font-bold ${
                      n.tag === "热" ? "bg-primary-500 text-background-50" : "bg-accent-500 text-background-50"
                    }`}
                  >
                    {n.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <span className="text-xs font-semibold text-primary-600">{n.cat}瓜 · 实时动态</span>
                  <h3 className="mt-2 font-heading text-base font-black leading-snug text-foreground-950 md:text-lg">
                    {n.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{n.summary}</p>
                  <a
                    href="#subscribe"
                    className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition hover:text-primary-700"
                  >
                    查看讨论进展 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}

        {/* 完整热榜 + 引导 */}
        <div id="feed" className="mt-14 grid scroll-mt-24 grid-cols-1 gap-8 rounded-2xl bg-foreground-950 p-6 md:p-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-fire-line"></i> 实时热榜 TOP10
            </span>
            <h3 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-3xl">
              此刻最热，全网都在吃
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              榜单基于实时讨论热度与站内浏览综合生成，每 5 分钟自动更新一次。上榜话题均带来源标注，后续进展会持续跟进。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-400"
            >
              订阅最新进展 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
          <ol className="divide-y divide-background-800/80">
            {hotRank.map((h) => (
              <li key={h.rank}>
                <a href="#subscribe" className="group flex items-center gap-3 py-2.5">
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                      h.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-800 text-background-300"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <span className="flex-1 truncate text-sm font-medium text-background-100 group-hover:text-primary-300">
                    {h.title}
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-accent-400">
                    <i className="ri-fire-fill"></i>
                    {h.heat}k
                  </span>
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}